document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.scroll-container').forEach((container) => {
    const scrollList = container.querySelector('.stats-slider, .brand-slider');
    const scrollbar = container.querySelector('.stats-scrollbar');
    const thumb = container.querySelector('.stats-scrollbar__thumb');

    if (!scrollList || !scrollbar || !thumb) {
      return;
    }

    const getScrollMetrics = () => {
      const trackWidth = scrollbar.clientWidth;
      const viewWidth = scrollList.clientWidth;
      const scrollWidth = scrollList.scrollWidth;
      const maxScroll = scrollWidth - viewWidth;
      const thumbWidth = Math.max((viewWidth / scrollWidth) * trackWidth, 48);
      const maxThumbTravel = trackWidth - thumbWidth;

      return {
        trackWidth,
        viewWidth,
        scrollWidth,
        maxScroll,
        thumbWidth,
        maxThumbTravel,
      };
    };

    const updateScrollbar = () => {
      const isScrollable = scrollList.scrollWidth > scrollList.clientWidth;
      scrollbar.hidden = !isScrollable;

      if (!isScrollable) {
        return;
      }

      const { maxScroll, thumbWidth, maxThumbTravel } = getScrollMetrics();
      const thumbLeft = maxScroll > 0
        ? (scrollList.scrollLeft / maxScroll) * maxThumbTravel
        : 0;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${thumbLeft}px)`;
    };

    const scrollFromThumbLeft = (thumbLeft) => {
      const { maxScroll, maxThumbTravel } = getScrollMetrics();
      scrollList.scrollLeft = maxThumbTravel > 0
        ? (thumbLeft / maxThumbTravel) * maxScroll
        : 0;
    };

    scrollbar.addEventListener('click', (event) => {
      if (event.target === thumb) {
        return;
      }

      const trackRect = scrollbar.getBoundingClientRect();
      const clickOffset = event.clientX - trackRect.left;
      const { thumbWidth, maxThumbTravel } = getScrollMetrics();
      const targetThumbLeft = Math.min(
        Math.max(clickOffset - thumbWidth / 2, 0),
        maxThumbTravel,
      );

      scrollFromThumbLeft(targetThumbLeft);
    });

    let dragStartX = 0;
    let dragStartThumbLeft = 0;

    thumb.addEventListener('pointerdown', (event) => {
      event.preventDefault();

      const transform = thumb.style.transform;
      const match = transform.match(/translateX\(([-\d.]+)px\)/);
      dragStartX = event.clientX;
      dragStartThumbLeft = match ? parseFloat(match[1]) : 0;
      thumb.setPointerCapture(event.pointerId);
    });

    thumb.addEventListener('pointermove', (event) => {
      if (!thumb.hasPointerCapture(event.pointerId)) {
        return;
      }

      const { maxThumbTravel } = getScrollMetrics();
      const targetThumbLeft = Math.min(
        Math.max(dragStartThumbLeft + (event.clientX - dragStartX), 0),
        maxThumbTravel,
      );

      scrollFromThumbLeft(targetThumbLeft);
    });

    thumb.addEventListener('pointerup', (event) => {
      if (thumb.hasPointerCapture(event.pointerId)) {
        thumb.releasePointerCapture(event.pointerId);
      }
    });

    scrollList.addEventListener('scroll', updateScrollbar, { passive: true });
    window.addEventListener('resize', updateScrollbar);
    window.addEventListener('load', updateScrollbar);

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(updateScrollbar);
      resizeObserver.observe(scrollList);
      resizeObserver.observe(scrollbar);
    }

    updateScrollbar();
  });
});
